import { render, staticRenderFns } from "./ValidarDocumento.vue?vue&type=template&id=4a4b1942&"
import script from "./ValidarDocumento.vue?vue&type=script&lang=js&"
export * from "./ValidarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports